import { COLUMN_ACCESS_GROUPS_COUNT, COLUMN_DESCRIPTION, COLUMN_NAME } from "../../constants/column-types";
import { TableColumn } from "../table/TableColumn";


const AccessProfileColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,                
        active: true,
        isDefault: true,
        translationKey: "name",     
        columnId: COLUMN_NAME
    },
    {
        heading: "Description",
        accessor: "description",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "description",
        columnId: COLUMN_DESCRIPTION,
    },
    {
        heading: "Access Groups",
        accessor: "totalGroups",
        isNumeric: true,
        id: 2,
        active: true,
        translationKey: "accessGroups",
        columnId: COLUMN_ACCESS_GROUPS_COUNT
    },
    {
        heading: "Floor Groups",
        accessor: "totalFloorGroups",
        isNumeric: true,
        id: 3,
        active: true,
        translationKey: "floorGroups",
    }
];

export default AccessProfileColumns;
